import {MuWidget} from "mu-widget/lib/MuWidget";
import {MuBinder} from "mu-widget/lib/MuBinder";
import {MuLabelFor} from "mu-widget/lib/MuLabelFor";
import {MuKeyBind} from "mu-widget/lib/MuKeyBind";

const {setupFilters} = require("./BindFilters");

MuWidget.registerAll(
	require("./UiScripting"),
	require("./Htmlarea"),
	require("./UiFlashMessage"),
	require("./UiSelector"),
	require("./TicketTree"),
	require("./InvoiceApproval"),
	require("./UiFlashMessage"),
	require("./AccountSelector"),
	require("./SearchSelector"),
	require("./ApprovingSchemaEditor"),
	require("./TicketTree"),
	require("./AccountRoles"),
	require("./ShareButton"),
	require("./TPFAttaches"),
	require("./TreeSelector"),
	require("./MultiUpload"),
	require("./TicketFormField"),
	require("./WorklogSimple"),
	require("./ShowMore"),
	require("./AccountRolesField"),
	require("./BulkStateChange"),
	require("./AccountRolesField"),
	require("./UiBilling"),
	require("./UiSavedFilters"),
	require("./UiSavedFiltersAdmin"),
	require("./UiNotify"),
	require("./UrlInput"),
	require("./ShowMore"),
	require("./Course"),
	require("./CourseEditor"),
	require("./SearchSelector"),
	require("./UiSelect"),
	require("./components/UiTable"),
	require("./components/UiTomSelect"),
	require("./components/UiBuSubjectSelector"),
	require("./components/UiOrgProjectSelector"),
	require("./components/UiAccountSelector"),
	require("./components/UiDateFilter"),
	require("./components/UiRadioList"),
	require("./components/UiPager"),
	require('./components/UiTree'),
	require('./components/UiInlineTreeSelector'),

	require("./dms/UiDms"),
	require("./dms/UiBuSubjectEditor"),
	require("./dms/UiDmsDocumentEditor"),
	require("./dms/UiBuSubjects"),
	require("./dms/UiDmsDocuments"),
	require("./dms/UiDocumentListPreview"),
	require('./dms/UiDmsAttaches'),
	require('./dms/UiDmsHistory'),
	require('./dms/UiDmsOrgProjects'),
	require('./dms/UiNewDocumentAttach'),

	require('./pqm/ProcDataField'),

	require('./UiProjectImport'),
	// require("./dms/fields/FieldInput"),
	// require("./dms/fields/FieldSelect"),
	// require("./dms/fields/FieldTree"),
	// require("./dms/fields/FieldSearch"),
	// require("./dms/fields/FieldOrgProject"),
	// require("./dms/fields/FieldBuSubject"),

);
MuLabelFor.register(MuWidget, true);
setupFilters();
MuWidget.registerAs(require("./IMuWidget").IMuWidget, ".")

MuBinder.register(MuWidget);
MuWidget.fixOldWidgets = "silent";
MuKeyBind.register(MuWidget);
MuWidget.startup(undefined, function(muRoot) {
	window.rootMuWidget = muRoot;
});
